// extracted by mini-css-extract-plugin
export var card = "ContactForm-module--card--aee72";